import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Capture PWA install event before React mounts
let _deferredInstallPrompt: any = null;
window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); _deferredInstallPrompt = e; });
export const getPwaInstallPrompt = () => _deferredInstallPrompt;
export const clearPwaInstallPrompt = () => { _deferredInstallPrompt = null; };

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

serviceWorkerRegistration.register();
